export default __webpack_public_path__ + "static/media/faqpanel-bar.9c703a87.png";